import { isRequires } from 'Utils/router';
import store from 'Store';

function requestKYC(to, from, next) {
  // Go to profile user tab, only if user not in profile already
  if (!from.name || !from.name.startsWith('profile')) {
    next({ name: 'profile', params: { tab: 'accounts' }, query: { open: 'verification' } });
  }
}

export async function resolveKYC(to, from, next) {
  const isRequiresKYCComplete = isRequires(to, 'requiresKYCComplete');
  if (isRequiresKYCComplete) {
    await store.getters['profile/profileDataPromise'];
    if (!store.getters['profile/isIdVerificationComplete']) {
      requestKYC(to, from, next);
      return Promise.reject(new Error('KYC complete required'));
    }
  }
  return Promise.resolve();
}
